import { Shield, Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface TrustBadgeProps {
  trustedCount: number;
  isTrusted: boolean;
  variant?: "default" | "compact" | "icon-only";
  className?: string;
}

const TrustBadge = ({ trustedCount, isTrusted, variant = "default", className }: TrustBadgeProps) => {
  if (!isTrusted && trustedCount === 0) return null;

  const getVariantClasses = () => {
    switch (variant) {
      case "compact":
        return "text-xs px-2 py-1";
      case "icon-only":
        return "p-1";
      default:
        return "text-sm px-3 py-1";
    }
  };

  const showTrustBadge = isTrusted && trustedCount >= 10;
  const showCount = trustedCount > 0;

  if (variant === "icon-only" && showTrustBadge) {
    return (
      <div className={cn("flex items-center", className)}>
        <Shield className="w-4 h-4 text-primary fill-primary/20" />
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {showTrustBadge && (
        <Badge 
          variant="secondary" 
          className={cn(
            "bg-primary/20 text-primary border-primary/30 flex items-center gap-1",
            getVariantClasses()
          )}
        >
          <Shield className="w-3 h-3 fill-current" />
          {variant !== "icon-only" && "Trusted by Community"}
        </Badge>
      )}
      
      {showCount && variant !== "icon-only" && (
        <span className="text-sm text-muted-foreground">
          Trusted by {trustedCount} {trustedCount === 1 ? 'member' : 'members'}
        </span>
      )}
    </div>
  );
};

export default TrustBadge;